import { CustomTheme, Theme, defaultTheme } from "matsuri-ui"

export const theme: Theme & CustomTheme = {
    ...defaultTheme,
    palette: {
        ...defaultTheme.palette,
        intentions: {
            ...defaultTheme.palette.intentions,
            primary: {
                ...defaultTheme.palette.intentions.primary,
                main: "#5f4fc4",
                light: "#B2A3E1",
                dark: "#372e8e"
            },
            hubspotBrand: {
                // light, darkは20%ずらしで適当に生成しているので正しいものではないです
                main: "#ff5c35",
                light: "#ffae9b",
                dark: "#ce2800",
                contrastText: "#fff"
            }
        }
    }
}
